export type SubcategoryOrderBy = 'CREATION_DATE' | 'TITLE';
export type SubcategoryOrderDir = 'ASC' | 'DESC';

export interface SubcategoryFilters {
  subcategoryTitle: string;
  createdOnFrom: string | null;
  createdOnTo: string | null;
  lastUpdatedOnFrom: string | null;
  lastUpdatedOnTo: string | null;
  orderBy: SubcategoryOrderBy;
  orderDir: SubcategoryOrderDir;
}

export const DEFAULT_SUBCATEGORY_FILTERS: SubcategoryFilters = {
  subcategoryTitle: '',
  createdOnFrom: null,
  createdOnTo: null,
  lastUpdatedOnFrom: null,
  lastUpdatedOnTo: null,
  orderBy: 'CREATION_DATE',
  orderDir: 'ASC',
};
